module.exports = __webpack_public_path__ + "img/light_5.da4b9ba3.png";